import { handleResponse } from '../helpers'

export const authService = {
  login,
  logout
};

function login(username, password) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ 'username': username, 'password': password })
  };
  return fetch( process.env.VUE_APP_API_URL + '/auth/signin', requestOptions)
    .then(handleResponse)
    .then(response => {
      if (response.token) {
        localStorage.setItem('token', JSON.stringify(response.token));
      }
      return response.user;
    });
}

function logout() {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  };
  return fetch( process.env.VUE_APP_API_URL + '/auth/signout', requestOptions)
    .then(handleResponse)
    .then(response => {
      localStorage.removeItem('token');
      return response;
    });
}
